'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyRatio = exports.Currency = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _bignumber = require('bignumber.js');

var _bignumber2 = _interopRequireDefault(_bignumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function amountToBigNumber(amount) {
  if (amount instanceof Currency || typeof amount.toBigNumber === 'function') return amount.toBigNumber();

  var value = (0, _bignumber2.default)(amount);
  if (value.isNaN()) throw new Error('amount "' + amount + '" is not a number');
  return value;
}

var Currency = exports.Currency = function () {
  function Currency(amount) {
    var shift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    (0, _classCallCheck3.default)(this, Currency);

    if (shift === 'wei') shift = -18;
    if (shift === 'ray') shift = -27;
    if (shift === 'rad') shift = -45;
    this._amount = shift ? amountToBigNumber(amount).shiftedBy(shift) : amountToBigNumber(amount);
    this.symbol = '???';
  }

  (0, _createClass3.default)(Currency, [{
    key: 'isEqual',
    value: function isEqual(other) {
      return this._amount.eq(other._amount) && this.symbol == other.symbol;
    }
  }, {
    key: 'toString',
    value: function toString() {
      var decimals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      return this._amount.toFixed(decimals) + ' ' + this.symbol;
    }
  }, {
    key: 'toBigNumber',
    value: function toBigNumber() {
      return this._amount;
    }
  }, {
    key: 'toNumber',
    value: function toNumber() {
      return this._amount.toNumber();
    }
  }, {
    key: 'toFixed',
    value: function toFixed() {
      var shift = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (shift === 'wei') shift = 18;
      if (shift === 'ray') shift = 27;
      if (shift === 'rad') shift = 45;

      // always round down so that we never attempt to spend more than we have
      return this._amount.shiftedBy(shift).integerValue(_bignumber2.default.ROUND_DOWN).toFixed();
    }
  }, {
    key: 'isSameType',
    value: function isSameType(other) {
      return this.symbol === other.symbol;
    }
  }]);
  return Currency;
}();

// FIXME: this is not exactly analogous to Currency above, because all the
// different pairs are instances of the same class rather than subclasses in
// their own right. but for now it works fine, because it's the wrapper
// functions that are used externally anyway. so if we want to be consistent, we
// could either create subclasses for each ratio, or refactor Currency so it
// also just stores its symbol in the instance rather than the subclass.


var CurrencyRatio = exports.CurrencyRatio = function (_Currency) {
  (0, _inherits3.default)(CurrencyRatio, _Currency);

  function CurrencyRatio(amount, numerator, denominator, shift) {
    (0, _classCallCheck3.default)(this, CurrencyRatio);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CurrencyRatio.__proto__ || (0, _getPrototypeOf2.default)(CurrencyRatio)).call(this, amount, shift));

    _this.numerator = numerator;
    _this.denominator = denominator;
    _this.symbol = numerator.symbol + '/' + denominator.symbol;
    return _this;
  }

  return CurrencyRatio;
}(Currency);

var mathFunctions = [['plus', 'add'], ['minus', 'sub'], ['times', 'multipliedBy', 'mul'], ['div', 'dividedBy'], ['shiftedBy']];

var booleanFunctions = [['isLessThan', 'lt'], ['isLessThanOrEqualTo', 'lte'], ['isGreaterThan', 'gt'], ['isGreaterThanOrEqualTo', 'gte'], ['eq']];

function assertValidOperation(method, left, right) {
  if (!right && right !== 0) {
    throw new Error('Invalid operation: ' + left.symbol + ' ' + method + ' with no right operand');
  }

  if (!(right instanceof Currency) || left.isSameType(right)) return;

  if (right instanceof CurrencyRatio) {
    // only supporting Currency as a left operand for now, though we could
    // extend this to support ratio-ratio math if needed
    switch (method) {
      case 'times':
        if (left.isSameType(right.denominator)) return;
        break;
      case 'div':
        if (left.isSameType(right.numerator)) return;
        break;
    }
  } else {
    switch (method) {
      // division between two different units results in a ratio, e.g. USD/DAI
      case 'div':
        return;
    }
  }

  throw new Error('Invalid operation: ' + left.symbol + ' ' + method + ' ' + right.symbol);
}

function bigNumberFnResult(method, left, right, value) {
  if (right instanceof CurrencyRatio) {
    switch (method) {
      case 'times':
        return new right.numerator(value);
      case 'div':
        return new right.denominator(value);
    }
  }

  if (!(right instanceof Currency) || left.isSameType(right)) {
    if (left instanceof CurrencyRatio) {
      return new left.constructor(value, left.numerator, left.denominator, left.shift);
    }
    return new left.constructor(value);
  }

  return new CurrencyRatio(value, left.constructor, right.constructor);
}

function bigNumberFnWrapper(method, isBoolean) {
  return function (other) {
    assertValidOperation(method, this, other);

    var otherBigNumber = other instanceof Currency ? other.toBigNumber() : other;

    var value = this.toBigNumber()[method](otherBigNumber);
    return isBoolean ? value : bigNumberFnResult(method, this, other, value);
  };
}

(0, _assign2.default)(Currency.prototype, mathFunctions.reduce(function (output, _ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      method = _ref2[0],
      aliases = _ref2.slice(1);

  output[method] = bigNumberFnWrapper(method);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(aliases), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var alias = _step.value;

      output[alias] = output[method];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return output;
}, {}), booleanFunctions.reduce(function (output, _ref3) {
  var _ref4 = (0, _toArray3.default)(_ref3),
      method = _ref4[0],
      aliases = _ref4.slice(1);

  output[method] = bigNumberFnWrapper(method, true);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(aliases), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var alias = _step2.value;

      output[alias] = output[method];
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return output;
}, {}));